import type { UserPresenceState } from '@annoteer/sync-layer';

export interface PresenceAvatarProps {
  user: UserPresenceState;
  showPage?: boolean;
}

export function PresenceAvatar({ user, showPage = false }: PresenceAvatarProps) {
  const initials = user.displayName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="presence-avatar" title={user.displayName}>
      <div className="presence-avatar__circle" style={{ backgroundColor: user.color }}>
        {initials}
      </div>
      <span className="presence-avatar__online" />
      <div className="presence-avatar__tooltip">
        <div className="presence-avatar__tooltip-name">{user.displayName}</div>
        {showPage && <div className="presence-avatar__tooltip-page">Page {user.currentPage}</div>}
      </div>
    </div>
  );
}
